import { INCREMENT, DECREMENT } from "../allAction/counterActions";
import { SET_ME_DATA } from "../allAction/authActions";

const persistedMeData = JSON.parse(localStorage.getItem("meData") || "null");

const initialState = {
  counter: 0,
  meData: persistedMeData,
};

export const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case INCREMENT:
      return { ...state, counter: state.counter + 1 };

    case DECREMENT:
      return { ...state, counter: state.counter - 1 };

    case SET_ME_DATA:
      return { ...state, meData: action.payload };

    default:
      return state;
  }
};
